import s from './state'
import * as a from './actions'
import * as m from './mutations'
import * as g from './getters'

// Namespace Vuex `professional-waitlist` (nomes congelados em
// contracts/juncao-paralela.md). Módulo de topo, no mesmo padrão de
// `aawz-drive/store/index.js`: quem registra (fora do escopo desta task) faz
// `store.registerModule('professional-waitlist', { ...professionalWaitlistStore, namespaced: true })`.
export const state = s
export const actions = { ...a }
export const mutations = { ...m }
export const getters = { ...g }
